import {iosShareSvg as Icon__small__iosShareSvg} from '../Icon__small/Icon__small--iosShare.js';
import {iosShareSvg as Icon__xsmall__iosShareSvg} from '../Icon__xsmall/Icon__xsmall--iosShare.js';

export var iosShare = {
  name: 'iosShare',
  category: 'icon',
  colorable: true,
  svg: Icon__small__iosShareSvg,
  alt: {
    Icon__small: Icon__small__iosShareSvg,
    Icon__xsmall: Icon__xsmall__iosShareSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
